import { AddonUpsell, GoalUpsell, UpgradeUpsell, Upsell } from '@/interfaces/models/Upsell';
import { UpsellApiService } from '@/api/http/UpsellApiService';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/interfaces/stores/RootState';
import { AxiosResponse } from 'axios';
import { Company } from '@/interfaces/models/Company';
import { UpsellType } from '@/enums/UpsellType';

interface UpsellState {
  goal: Upsell<GoalUpsell> | null;
  addon: Upsell<AddonUpsell> | null;
  upgrade: Upsell<UpgradeUpsell> | null;
}

const api: UpsellApiService = new UpsellApiService();

const state: UpsellState = {
  goal: null,
  addon: null,
  upgrade: null,
};

const actions: ActionTree<UpsellState, RootState> = {
  showByVenueAndType({ commit, state }, data: { venue: string; type: UpsellType }) {
    return api.showByVenueAndType(data.venue, data.type).then((res: AxiosResponse<Upsell>) => {
      commit('setUpsell', res.data);
    });
  },
  show({ commit }, data: { id: string }) {
    return api.show(data).then((res: AxiosResponse<Upsell>) => {
      commit('setUpsell', res.data);
    });
  },
  update({ commit, state }, data: Partial<Upsell>) {
    return api.update(data).then((res: AxiosResponse<Upsell>) => {
      commit('setUpsell', res.data);
    });
  },
  destroy({ commit }, data: { id: string; type: UpsellType }) {
    return api.softDelete({ id: data.id }).then(() => {
      commit('unsetUpsell', data.type);
    });
  },
  store({ commit }, data: Partial<Company>) {
    return api.store(data).then((res: AxiosResponse<Upsell>) => {
      commit('setUpsell', res.data);
    });
  },
};

const mutations: MutationTree<UpsellState> = {
  setUpsell(state: UpsellState, data: Upsell) {
    switch (data.type) {
      case UpsellType.ADDON:
        state.addon = data as Upsell<AddonUpsell>;
        break;
      case UpsellType.GOAL:
        state.goal = data as Upsell<GoalUpsell>;
        break;
      case UpsellType.UPGRADE:
        state.upgrade = data as Upsell<UpgradeUpsell>;
        break;
    }
  },
  unsetUpsell(state: UpsellState, type: UpsellType) {
    switch (type) {
      case UpsellType.ADDON:
        state.addon = null;
        break;
      case UpsellType.GOAL:
        state.goal = null;
      case UpsellType.UPGRADE:
        state.upgrade = null;
    }
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
